import { useEffect, useState } from 'react';
import api from '../lib/axios';

interface FeatureFlags {
  'live-transcriptions': boolean;
}

const defaultFlags: FeatureFlags = {
  'live-transcriptions': false,
};

export function useFeatureFlags() {
  const [flags, setFlags] = useState<FeatureFlags>(defaultFlags);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/api/features')
      .then((res) => {
        setFlags(res.data.data);
      })
      .catch(() => {
        // Default to all flags off on failure
        setFlags(defaultFlags);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { flags, loading };
}
